export default function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : ''
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return sign + output
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
// module id = 122
// module chunks = 0